const storeDictEN = {
  store: "Store",
  storeSettings: "Settings",
  storeOrders: "Orders",
  storeSchedules: "Schedules",
  storeSchedulesSubtitle: "Manage schedules synced with Google Calendar",
  storeTotalOrders: "Total orders",
  storePendingOrders: "Pending orders",
  orderDetails: "Order details",
  storeOrderDetails: "Order details",
  storeProducts: "Products",
  myStore: "My Store",
  storePanelTitle: "Store panel",
  storePanelSubtitle: "Manage your store operations.",
  storeOperations: "Operations",
  storeRegisteredArticles: "Registered articles",
  storeRevenue: "Revenue",
  storePendingOperations: "Pending operations",
  sinceStart: "Since start",
  awaitingProcessing: "Awaiting processing",
  latestOrders: "Latest orders",
  allOrders: "All orders",
  newProduct: "New product",
  settingsTabGeneral: "General",
  settingsTabLocationContact: "Location and contact",
  settingsTabIntegrations: "Integrations",
  integrationsDisabled: "Disabled",
  backToPage: "Back to page",
  newProductOverlayTitle: "New product",
  stepGeneralInfo: "General information",
  stepGeneralInfoSubtitle: "Boost sales with detailed product information",
  stepPriceDetails: "Price details",
  stepPriceDetailsTitle: "Add product details",
  stepPriceDetailsSubtitle: "Increase sales with detailed product information",
  stepProductImage: "Product image",
  stepStockAvailability: "Stock & availability",
  stepSummary: "Summary",
  next: "Next",
  previous: "Previous",
  submitProduct: "Register product",
  cancel: "Cancel",
  filterByOrderId: "Order ID",
  filterByDateRange: "Date range",
  filterByStatus: "Status",
  search: "Search",
  customer: "Customer",
  product: "Product",
  service: "Service",
  downloadable: "Downloadable",
  integrationsComingSoon: "Coming soon",
  website: "Website",
  save: "Save",
  logo: "Logo",
  storeSettingsLogoHelp: "Image shown as your store logo. Recommended: 4:1 aspect ratio.",
  storeSettingsTitleHelp: "Name displayed for your store.",
  storeSettingsDescriptionHelp: "Short description of your store.",
  storeSettingsWebsiteHelp: "Your store or company website URL.",
  storeSettingsSocialHelp: "Username or profile path only (e.g. mypage for instagram.com/mypage).",
  storeSettingsMinOrderHelp: "Minimum order value to apply the selected freight rule.",
  storeSettingsFreightValueHelp: "Discount value or percentage applied when the rule is met.",
  storeSettingsClickToUpload: "Click to upload",
  storeSettingsOrDragDrop: "or drag and drop",
  storeSettingsLogoFormats: "PNG, JPG or WebP. Max 5 MB.",
  storeSettingsCategoriesHelp: "Categories your store belongs to.",
  storeSettingsAtecoHelp: "Search and add ATECO codes for your store activity.",
  storeSettingsStoreLinkHelp: "Lowercase letters and numbers only, up to 20 characters. Leave blank to not use a custom link.",
  storeSettingsStoreLinkPlaceholder: "mystore",
  storeSettingsCopyLink: "Copy link",
  storeSettingsLinkCopied: "Link copied!",
  storeSettingsCopyLinkDisabled: "Save the custom link to be able to copy it.",
  free: "Free",
  productInfo: "Product information",
  editProduct: "Edit product",
  storeEditTabGeneral: "General details",
  storeEditTabImages: "Product images",
  storeEditTabStock: "Stock status",
  storeEditImagesHint: "Use the General details tab to manage product images.",
  storeEditStockHint: "Use the General details tab to manage stock and publication.",
  noProducts: "No products registered.",
  errorLoadingProduct: "Error loading product.",
  orderDetailsSubtitle: "You can monitor and manage the order details.",
  orderDetailsStep1Send: "Send order",
  orderDetailsStep2Delivered: "Order delivered",
  orderDetailsStep3Payment: "Receive payment",
  orderDetailsStep4Completed: "Purchase completed",
  orderDetailsAlertToProcess:
    "To process. You have received a new order! Check product availability and start preparation.",
  orderDetailsTransactionId: "Transaction ID",
  orderDetailsSummaryPurchase: "Purchase summary",
  orderDetailsSubtotal: "Subtotal",
  orderDetailsCoupon: "Coupon",
  orderDetailsVat: "VAT",
  orderDetailsShippingCosts: "Shipping costs",
  orderDetailsTotal: "Total",
  orderDetailsTotalReceived: "Total received",
  orderDetailsCashback: "Cashback",
  orderDetailsPaymentMethod: "Payment method",
  orderDetailsCreditCard: "Credit card",
  orderDetailsExtracredit: "Extracredit",
  orderDetailsBuyer: "Buyer",
  orderDetailsContact: "Contact",
  orderDetailsPhone: "Phone",
  orderDetailsEmail: "Email",
  orderDetailsShippingData: "Shipping data",
  orderDetailsStatusToProcess: "To process",
  orderDetailsStatusShipped: "Shipped",
  orderDetailsStatusDelivered: "Delivered",
  orderDetailsCancelOrder: "Cancel order",
  orderDetailsSendProduct: "Send product",
  orderDetailsOrderConfirmed: "Order confirmed",
  orderDetailsPaymentApproved: "Payment was approved.",
  orderDetailsProductInTransit: "Product is in transit.",
  orderDetailsProductDelivered: "Product was delivered.",
  orderDetailsLoading: "Loading...",
  shippingIncluded: "Shipping included",
  notifyAllUsers: "Notify all users",
  notifyMyEconomicCircle: "Notify my economic circle",
  notifications: "Notifications",
  fileForDownload: "File for download",
  sampleFileOptional: "Sample / preview (optional)",
  downloadFileType: "File type",
  downloadTypeAudio: "Audio",
  downloadTypeVideo: "Video",
  downloadTypeImage: "Image",
  downloadTypeDocument: "Document",
  publishProductNow: "Publish product now",
  uploadZoneInstruction: "Choose a file or drag it here.",
  uploadZoneFormatsImages: "JPEG, PNG and MP4 formats, up to 50 MB.",
  uploadZoneFormatsFile: "All formats, up to 100 MB.",
  browseFiles: "Browse files",
  primaryImage: "Primary",
  activate: "Activate",
  confirmCode: "Confirm code",
  whatsappDisconnected: "WhatsApp disconnected",
  whatsappHasBeenDisconnected: "WhatsApp has been successfully disconnected.",
  activated: "Activated",
  deactivated: "Deactivated",
  removeIntegration: "Remove integration",
  confirmRemoveIntegration:
    "Are you sure you want to remove this integration? This action cannot be undone.",
  confirmation: "Confirmation",
  yes: "Yes",
  no: "No",
  googleCalendar: "Google Calendar",
  googleCalendarDescription: "Sync your events and appointments with Google Calendar",
  apiKey: "API Key",
  clientId: "Client ID",
  clientSecret: "Client Secret",
  configure: "Configure",
  integrationsDescription: "Connect your store with external tools to optimize your workflow",
  whatsappIntegrationDescription: "Connect your store to WhatsApp for direct customer service",
  phoneNumber: "Phone number",
  phoneNumber1: "Phone number",
  enterYourPhoneNumber: "Enter your phone number",
  attention: "Attention",
  pleaseProvidePhoneNumber: "Please provide a phone number",
  codeSent: "Code sent",
  confirmationCodeSentToWhatsApp: "Confirmation code sent to WhatsApp",
  error: "Error",
  errorConnectingToServer: "Error connecting to server",
  pleaseProvideConfirmationCode: "Please provide the confirmation code",
  success: "Success",
  whatsappConfiguredSuccessfully: "WhatsApp configured successfully",
  invalidConfirmationCode: "Invalid confirmation code",
  configurationSavedSuccessfully: "Configuration saved successfully",
  goBackAndResendCode: "Go back and resend code",
  confirmationCode: "Confirmation code",
  enterReceivedCode: "Enter the received code",
  integrationData: "Integration data",
  redirectedToGoogleAuth:
    "Redirected to Google authentication. Complete the process in the new tab.",
  errorGettingAuthUrl: "Error getting authentication URL",
  googleCalendarDisconnected: "Google Calendar disconnected",
  googleCalendarHasBeenDisconnected: "Google Calendar has been successfully disconnected.",
  errorDisconnectingGoogleCalendar: "Error disconnecting Google Calendar. Please try again.",
  noSchedulesYet: "No schedules yet",
  scheduleConnectGoogleCalendar:
    "Connect Google Calendar in the integrations tab to sync your schedules",
  confirmed: "Confirmed",
  pending: "Pending",
  manageOrders: "Manage your orders",
  manageProducts: "Manage your products",
  manageSchedules: "Manage your schedules",
  viewSchedules: "View schedules",
  scheduleSetupTitle: "Initial setup required",
  scheduleSetupDescription: "To use the scheduling system, follow the steps below:",
  scheduleStep1Title: "Connect Google Calendar",
  scheduleStep1Description: "Connect your Google Calendar account to sync schedules",
  scheduleStep1Connected: "Google Calendar successfully connected",
  scheduleStep2Title: "Configure time preferences",
  scheduleStep2Description: "Define the days and times customers can book your services",
  scheduleStep2Configured: "Time preferences configured",
  connect: "Connect",
  integrationComplete: "Integration complete!",
  yourAccountIsNowConnected: "Your account is now connected.",
  whatsappBotReady: "WhatsApp bot is ready to read your schedule.",
  integrationIncomplete: "Integration incomplete",
  youNeedToCompleteTheFollowingSteps:
    "You need to complete the following steps to start receiving schedule bookings:",
  standardAppointmentLength: "Standard appointment length (minutes)",
  scheduleBufferLabel: "Buffer between appointments (min)",
  scheduleBufferHelp: "Break time between appointments",
  scheduleAppointmentLengthHelp: "Default appointment duration",
  scheduleWorkStartLabel: "Work start time",
  scheduleWorkEndLabel: "Work end time",
  scheduleSelectDays: "Select working days",
  scheduleClientInstructionsLabel: "Instructions for the client",
  scheduleClientInstructionsPlaceholder: "E.g.: Please arrive 15 minutes before your appointment.",
  scheduleClientInstructionsHelp:
    "These instructions will be sent to the client upon booking confirmation.",
  monday: "Monday",
  tuesday: "Tuesday",
  wednesday: "Wednesday",
  thursday: "Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  openYourGoogleCalendar: "Open your Google Calendar",
  availability: "Availability",
  scheduleStep3Title: "Schedules & bookings",
  scheduleStep3Description: "Manage appointments and support requests directly from your calendar.",
  configureYourAvailability: "Configure your availability",
  defineDaysAndTimes: "Define the days and times customers can book your services",
  removeWhatsAppIntegration: "Remove WhatsApp integration?",
  removeWhatsAppIntegrationDescription:
    "The phone number will be removed from our systems and the contact button will no longer be visible to your store's customers. You can reactivate the service at any time.",
  removeGoogleCalendarIntegration: "Remove Google Calendar integration?",
  removeGoogleCalendarIntegrationDescription:
    "The connection to Google Calendar will be removed and your schedules will no longer be synced. You can reactivate the service at any time.",
  remove: "Remove",
  physicalStore: "Physical Store",
  physicalStoreConventionTitle: "Physical Store Convention",
  physicalStoreConventionSubtitle:
    "Read and sign the convention to activate your physical store and start receiving payments.",
  physicalStoreConventionAlreadySigned: "Convention already signed",
  physicalStoreConventionAlreadySignedDesc: "You have already signed the physical store convention. No further action is required.",
  physicalStoreConventionAccept: "I have read and accept the terms of the convention",
  physicalStoreConventionConfirm: "Confirm and sign",
  physicalStoreConventionSignedSuccess: "Convention signed successfully!",
  physicalStoreConventionSignedError: "Error signing the convention. Please try again.",
  physicalStoreConventionLoading: "Loading convention...",
  physicalStoreConventionCommercialName: "Commercial name",
  physicalStoreConventionCompanyName: "Company name",
  physicalStoreConventionAddress: "Address",
  physicalStoreConventionNumber: "Number",
  physicalStoreConventionCity: "City",
  physicalStoreConventionPostalCode: "Postal code",
  physicalStoreConventionProvince: "Province / State",
  physicalStoreConventionPhone: "Phone",
  physicalStoreConventionProofPhoto: "Establishment photo",
  physicalStoreConventionProofPhotoPlaceholder: "Click to select an image",
  physicalStoreConventionUploading: "Uploading...",
  physicalStoreConventionPendingTitle: "Proof under review",
  physicalStoreConventionPendingMessage: "Your proof has been submitted and is awaiting review. You will be able to use the physical store soon.",
  physicalStoreConventionRejectedTitle: "Proof rejected",
  physicalStoreConventionApprovedTitle: "Physical store approved",
  physicalStoreConventionApprovedMessage: "Your physical store has been approved. You can now use all physical payment features.",
  physicalStoreConventionLegalRepresentative: "Legal representative name",
  physicalStoreConventionTaxId: "Tax ID",
  physicalStoreConventionMerchantCategory: "Merchant category",
  physicalStoreConventionViewDoc: "View convention terms",
  physicalStoreNewPayment: "New payment",
  physicalStoreNewPaymentDesc: "Create a new QR Code charge",
  physicalStorePaymentsList: "Payments history",
  physicalStorePaymentsListDesc: "View all received payments",
  physicalStoreCameraPayment: "Pay with camera",
  physicalStoreCameraPaymentDesc: "Scan QR Code to receive",
  physicalStoreVerificationTitle: "Physical store verification",
  physicalStoreVerificationSubtitle: "Submit proof to enable charges",
  physicalStoreVerificationPendingSubtitle: "Your proof is under review",
  physicalStoreVerificationPendingMessage:
    "Your proof has been submitted and is awaiting review. You will be able to create charges soon.",
  physicalStoreVerificationRejected: "Proof rejected",
  physicalStoreVerificationAddressPlaceholder: "Street / Ave.",
  physicalStoreVerificationNumberPlaceholder: "No.",
  physicalStoreVerificationPostalCodePlaceholder: "00000-000",
  physicalStoreVerificationStatePlaceholder: "State",
  addProduct: "Add product",
  searchProductByName: "Search by product name",
  productsViewGrid: "Grid view",
  productsViewList: "List view",
  productListValue: "Value",
  productListRegistration: "Registered",
  sortBy: "Sort",
  sortMostRecent: "Most recent",
  sortOldest: "Oldest",
  sortHighestValue: "Highest value",
  unpublishProduct: "Unpublish product",
  publishProduct: "Publish product",
  notifyUsers: "Notify users",
  notifyEconomicCircle: "Notify economic circle",
  productTypeModalTitle: "What type of product or service are you going to register?",
  productTypePhysical: "Physical product",
  productTypePhysicalDesc: "Products that will be delivered to customers.",
  productTypeService: "Service",
  productTypeServiceDesc: "A service you provide to customers.",
  productTypeDigital: "Digital product",
  productTypeDigitalDesc: "Customers will be able to download your product.",
  addProductDetails: "Add product details",
  addProductDetailsSubtitle: "Describe your product details for display.",
  addServiceDetails: "Add service details",
  addServiceDetailsSubtitle: "Describe your service details for display.",
  productName: "Product name",
  productNamePlaceholder: "Enter the product name",
  serviceNamePlaceholder: "Enter the service name",
  productState: "Product condition",
  productStateNew: "New",
  productStateUsed: "Used",
  withVariation: "With variation?",
  withVariationHelp: "Ideal for items with different sizes, colors.",
  forSale: "For sale",
  forSaleHelp: "Publish for immediate display.",
  fullDescription: "Full description",
  fullDescriptionPlaceholder: "Enter a complete description of your product.",
  fullDescriptionPlaceholderService: "Enter a complete description of your service.",
  fullDescriptionTip: "Make the detailed description stand out",
  stock: "Stock",
  stockPlaceholder: "E.g.: 10",
  category: "Category",
  subcategory: "Subcategory",
  selectCategory: "Select a category",
  selectSubcategory: "Select a subcategory",
  selectFileType: "Select a file type",
  requiredFieldsHint: "* required fields to publish",
  productCharacteristics: "Product characteristics",
  productCharacteristicsSubtitle:
    "Organize information in groups. In each group, add a title and the information pairs that will appear on the product characteristics tab.",
  serviceCharacteristics: "Service characteristics",
  serviceCharacteristicsSubtitle:
    "Organize information in groups. In each group, add a title and the information pairs that will appear on the service characteristics tab.",
  noCharacteristics: "No characteristics registered.",
  createCharacteristics: "Create characteristics for my product",
  createCharacteristicsService: "Create characteristics for my service",
  characteristicsFooter: "This content will appear on the product Characteristics tab.",
  characteristicsFooterService: "This content will appear on the service Characteristics tab.",
  addGroup: "Add group",
  addItem: "Add item",
  characteristicTitle: "Title",
  characteristicDescription: "Description",
  groupNamePlaceholder: "Type the group name",
  characteristicTitlePlaceholder: "E.g.: Material",
  characteristicDescriptionPlaceholder: "E.g.: Premium cotton",
  saveCharacteristicGroup: "Save",
  removeCharacteristicGroup: "Remove group",
  characteristicGroupItem: "{count} item",
  characteristicGroupItems: "{count} items",
  unnamedCharacteristicGroup: "Characteristics",
  priceDetails: "Define price details",
  priceDetailsSubtitle: "How much the product will cost, which discounts and cashback will apply.",
  priceDetailsSubtitleService:
    "How much your service will cost, which discounts and cashback will apply.",
  discountAndShippingDetails: "Define discount and shipping details",
  discountAndShippingSubtitle:
    "Shipping type, product measurements, discounts and cashback to apply.",
  priceHelp: "Set how much you want to receive for the product.",
  priceHelpService: "Set how much you want to receive for the service.",
  discountOptional: "Discount (Optional)",
  discountHelp: "Show that your product is on sale.",
  discountHelpService: "Show that your service is on sale.",
  cashbackPercent: "Cashback percentage",
  cashbackHelpPrefix: "To understand how the final price is calculated, visit our",
  priceCalculator: "price calculator",
  productDimensions: "Enter your product dimensions",
  productDimensionsSubtitle: "Measurements are used to calculate shipping.",
  heightCm: "Height (cm)",
  widthCm: "Width (cm)",
  lengthCm: "Length (cm)",
  weightKg: "Weight (kg)",
  shipping: "Shipping",
  shippingHelp: "How you prefer shipping to be handled for your product.",
  shippingSimulator: "Shipping simulator",
  breadcrumbsAriaLabel: "Breadcrumb",
  freeShipping: "Free shipping",
  freeShippingDesc: "The store is responsible for shipping costs.",
  paidShipping: "Paid shipping",
  paidShippingDesc: "The customer pays shipping at checkout.",
  localPickup: "Local pickup",
  localPickupDesc: "The customer can pick up the order at the store.",
  productVariations: "Product variations",
  productVariationsSubtitle:
    "You can choose up to 2 attributes and up to 5 variations for each registered product.",
  addVariationOptions: "Add options such as color or size.",
  addAnotherOption: "Add another option",
  optionName: "Option name",
  optionValues: "Option values",
  addValue: "Add value",
  done: "Done",
  variant: "Variant",
  variantPrice: "Price",
  variantStock: "Stock",
  selectImage: "Select image",
  uploadedImages: "Uploaded images",
  addFiles: "Add files",
  confirm: "Confirm",
  addProductImages: "Add product images",
  addProductImagesSubtitle:
    "Use photos from different angles to offer a better experience to your customer.",
  addServiceImages: "Add service images",
  addServiceImagesSubtitle:
    "Use photos from different angles to offer a better experience to your customer.",
  uploadFiles: "Upload files",
  uploadZoneFormatsProductImages: "JPEG, PNG and WEBP formats. Up to 5 MB.",
  digitalProductFiles: "Your digital product files",
  digitalProductFilesSubtitle: "Upload the cover, the main file and an optional sample.",
  coverImage: "Cover image",
  coverImageHelp: "Image shown in the store.",
  coverImageFormats: "Accepted formats: JPG, PNG and WebP.",
  coverImageSize: "Max size: 3MB.",
  mainProductFile: "Main product file",
  mainProductFileHelp: "File the customer receives after purchase.",
  mainProductFileFormats: "Accepted formats: All formats.",
  mainProductFileSize: "Max size: 100MB.",
  previewSample: "Preview sample (optional)",
  previewSampleHelp: "A demo or reduced version of the product.",
  previewSampleFormats: "Accepted formats: All formats.",
  previewSampleSize: "Max size: 100MB.",
  selectFiles: "Select files",
  replaceFile: "Replace file",
  viewFile: "View",
  uploadedSuccessfully: "Uploaded successfully",
  requiredFilesToPublish: "Required files must be uploaded to publish the product.",
  dragDropOrSelect: "Drag and drop here",
  uploadZoneHelp: "or select a file from your computer.",
  register: "Register",
  noProductsFound: "No products found.",
  notifyConfirmUsers: "Do you want to notify all users about this product?",
  notifyConfirmCircle: "Do you want to notify your economic circle about this product?",
  notifyInsufficientBalance: "Insufficient ExtraBonus balance to send the notification.",
  productPublished: "Product published successfully.",
  productUnpublished: "Product unpublished successfully.",
  productNotified: "Notification sent successfully.",
  examplePlaceholder: "E.g.:",
};

export default storeDictEN;
